export default {
  "content": "<g clip-path=\"url(#icon_export_ios_svg__a)\"><path d=\"M13 5h-1.5c-.28 0-.5.22-.5.5s.22.5.5.5H13v9H3V6h1.5c.28 0 .5-.22.5-.5S4.78 5 4.5 5H3c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z\"/><path fill-rule=\"evenodd\" d=\"M10.75 3.25a.485.485 0 01-.7 0L8.79 2l-.29-.29V9c0 .28-.23.5-.5.5s-.5-.22-.5-.5V1.71L7.21 2 5.95 3.25a.485.485 0 01-.7 0c-.2-.19-.2-.51 0-.7l.11-.11L6.79 1l.83-.83C7.71.07 7.85 0 8 0c.13 0 .26.05.35.15l2.4 2.4c.2.19.2.51 0 .7z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"icon_export_ios_svg__a\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};